export default "__VITE_ASSET__Dv5zgHW4__"